// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface HealthFirstAidKitIconSignature {
  Element: SVGSVGElement;
}

export const HealthFirstAidKitIcon: TOC<HealthFirstAidKitIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 7H20C21.104 7 22 7.898 22 9V19C22 20.103 21.104 21 20 21H4C2.896 21 2 20.103 2 19V9C2 7.898 2.896 7 4 7H8V4C8 3.448 8.447 3 9 3H15C15.553 3 16 3.448 16 4V7ZM14 5H10V7H14V5ZM19.997 19H4V9H20L19.997 19ZM11 11H13V13H15V15H13V17H11V15H9V13H11V11Z"/>
</svg>
</template>;